import {
  Box,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";

const TokenLimitDropdown = ({
  defaultvalue,
  min,
  max,
  title,
  setFormData,
  formData,
  name,
}) => {
  const [tokenLimit, setTokenLimit] = useState(defaultvalue);

  const handleChange = (value) => {
    setTokenLimit(value);
    setFormData((prev) => ({
      ...prev,
      [name]: +value,
    }));
  };
  const calculateStep = (min, max) => {
    const range = max - min;

    if (range <= 1) return 0.1;
    if (range <= 10) return 1;
    if (range <= 100) return 5;
    return 10;
  };

  const getPrecision = (min, max) => {
    return max - min <= 1 ? 1 : 0;
  };

  return (
    <Box>
      <Popover size={"sm"}>
        <PopoverTrigger>
          <Button size={"xs"} variant="outline">
            T {tokenLimit}
          </Button>
        </PopoverTrigger>

        <PopoverContent w="250px" p={3} shadow="md">
          <PopoverBody>
            <Text fontWeight="bold">{title}</Text>
            <NumberInput
              value={Number(tokenLimit)}
              onChange={(valueString) => handleChange(Number(valueString))}
              min={min}
              max={max}
              step={calculateStep(min, max)} // Dynamically calculate step
              precision={getPrecision(min, max)} // Ensure decimal precision where needed
              clampValueOnBlur={false}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>

            <Text fontSize="sm" mt={2} color="gray.600">
              Range: {`${min} to ${max}`}
              <br />
              Default: {defaultvalue}
              <br />
              {`The token count of your prompt plus token limit cannot exceed 
                  the model’s maximum context length of ${max} tokens.`}
            </Text>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

export default TokenLimitDropdown;
